import {useCallback, useEffect, useState} from 'react';
import {noop} from '@utils/constants';
import {useEventListener} from 'usehooks-ts';

export const useResizeWindow = <T = number>(onResize: () => T = noop) => {
    const [width, setWidth] = useState<T>();
    const handleResize = useCallback(() => {
        if (onResize === noop) {
            const width = window.innerWidth;
            setWidth(width as any);
        } else {
            setWidth(onResize());
        }
    }, [onResize]);

    
    useEffect(() => {
        handleResize();
    }, [onResize]);

    useEventListener('resize', handleResize, window as any);

    return width;
};
